import React from "react"
import type { PossibleDuplicatePost } from "../../requests/posts"

interface Props {
  duplicate: PossibleDuplicatePost
  formattedDate: string
  onDismiss: () => void
}

export const DuplicateEventWarning: React.FC<Props> = ({
  duplicate,
  formattedDate,
  onDismiss,
}) => {
  return (
    <div className="bg-yellow-50 border border-yellow-300 text-yellow-900 rounded-sm px-3 py-2 mb-3 flex items-start justify-between gap-3">
      <div>
        <p className="font-bold mb-1">Has this show already been added?</p>
        <p className="text-sm">
          &quot;{duplicate.title}&quot; — {formattedDate}
          {duplicate.location_display_name && ` at ${duplicate.location_display_name}`}
        </p>
      </div>
      <div className="flex flex-col items-end gap-1 flex-none">
        <a
          href={duplicate.nada_path}
          target="_blank"
          rel="noreferrer"
          className="text-sm underline whitespace-nowrap"
        >
          View existing
        </a>
        <button
          type="button"
          onClick={onDismiss}
          className="text-sm underline whitespace-nowrap"
        >
          Continue anyway
        </button>
      </div>
    </div>
  )
}
